const isUuid = (s: string): boolean => (
  !!s &&
  !!s.trim().match(/^[0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12}$/)
)

export default isUuid
